import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { SettingsService } from '@core/config/settings.service';

export const MaintenanceGuard: CanActivateFn = () => {
  const maintenance = inject(SettingsService).maintenanceMode;
  const router = inject(Router);

  if (!maintenance) {
    return router.createUrlTree([]);
  }

  return true;
};
